module.exports = __webpack_public_path__ + "img/back.85b297bf.svg";